import EditTransaction from './EditTransaction';

const EditExpense = () => {
  return <EditTransaction transactionType="expense" returnTo="/expenses" isRecurring={false}/>;
};

export default EditExpense;